<template>
  <VModal ref="contactRequestUnsubscribeDialog" @close="$emit('close')">
    <template #default="modalProps">
      <div
        class="rounded shadow-xs bg-gray-100 overflow-hidden mx-auto lg:max-w-lg sm:w-full flex flex-col"
      >
        <div class="flex-none px-4 sm:px-6 py-5 border-b bg-white">
          <div class="flex items-center justify-between">
            <div class="flex-1">
              <h1 class="text-sm">Unsubscribe Contact</h1>
            </div>
            <button
              type="button"
              class="rounded-md text-gray-400 hover:text-gray-800 focus:outline-none"
              @click="modalProps.close"
            >
              <!-- Heroicon name: outline/x -->
              <svg
                class="h-6 w-6"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
        </div>
        <div class="flex-1 p-4 sm:p-6 bg-white">
          <BaseVeeForm
            :action="handleUnsubscribeContactRequest"
            @success="handleContactRequestUnsubscribed"
          >
            <!-- formProps
              isIdle, isPending, isResolved, isRejected, invalid
              errors, submit
            -->
            <template #default="formProps">
              <div>
                <BaseFormTextFieldWithValidator
                  v-bind="contactRequestIdFieldProps"
                  :value="data.contact_request_id"
                  :disabled="formProps.isPending"
                />
                <div class="space-y-8">
                  <BaseFormTextareaFieldWithValidator
                    v-model="data.reason"
                    v-bind="reasonFieldProps"
                    :disabled="formProps.isPending"
                  />
                  <BaseButton primary> Unsubscribe </BaseButton>
                </div>
              </div>
            </template>
          </BaseVeeForm>
        </div>
      </div>
    </template>
  </VModal>
</template>

<script>
import { accountUnsubscribedContactRequestsClient } from '@/api/clients';

export default {
  name: 'ContactRequestUnsubscribeDialog',
  props: {
    contactRequest: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      data: {
        contact_request_id: this.contactRequest.id,
        reason: '',
      },
    };
  },
  computed: {
    contactRequestIdFieldProps() {
      return {
        validator: {
          name: 'contact request',
          vid: 'contact_request_id',
          rules: { required: true },
        },
        field: {
          id: 'contact_request_id',
          inputType: 'hidden',
        },
      };
    },
    reasonFieldProps() {
      return {
        validator: {
          name: 'reason',
          vid: 'reason',
          rules: {
            required: false,
          },
        },
        field: {
          id: 'reason',
          label: 'Unsubscribe reason',
        },
      };
    },
  },
  methods: {
    handleUnsubscribeContactRequest() {
      return accountUnsubscribedContactRequestsClient.store(
        this.contactRequest.accountId,
        this.data
      );
    },
    handleContactRequestUnsubscribed() {
      this.$emit('contact-request:unsubscribed');
      this.$refs.contactRequestUnsubscribeDialog.close();
    },
  },
};
</script>
